import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={7}
    fill="currentColor"
    viewBox="0 0 12 7"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.88.29 6 4.17 2.12.29A.996.996 0 1 0 .71 1.7L5.3 6.29c.39.39 1.02.39 1.41 0L11.3 1.7a.996.996 0 0 0 0-1.41c-.39-.38-1.03-.39-1.42 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronDown;
